"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TOURNAMENT_PHASES = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _QuizTournamentCodeEntry = _interopRequireDefault(require("./QuizTournamentCodeEntry"));

var _QuizTournamentTeamChooser = _interopRequireDefault(require("./QuizTournamentTeamChooser"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _strings = require("../../../../config/strings");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _QuizTournamentEndScreen = _interopRequireDefault(require("./QuizTournamentEndScreen"));

var _TournamentStateHelper = _interopRequireWildcard(require("../../../helpers/TournamentStateHelper"));

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _BuildConstants = require("../../../utils/BuildConstants");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PAGES = {
  CODE_ENTRY: 'codeEntry',
  CHOOSE_TEAM: 'chooseTeam',
  WAIT_FOR_PLAY: 'waitForPLay',
  PLAY_GAMES: 'playGames',
  WAIT_FOR_END: 'waitForEnd',
  END_SCREEN: 'endScreen',
  END: 'end'
};
var TOURNAMENT_PHASES = {
  CHOOSE_TEAM: 'chooseTeam',
  WAIT_FOR_PLAY: 'waitForPlay',
  PLAY_GAMES: 'playGames',
  WAIT_FOR_END: 'waitForEnd',
  END: 'end'
};
exports.TOURNAMENT_PHASES = TOURNAMENT_PHASES;

var QuizTournament = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizTournament, _DataStoreComponent);

  var _super = _createSuper(QuizTournament);

  function QuizTournament(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, QuizTournament);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTournamentsUpdate", function () {
      if (_this.state.page === PAGES.CODE_ENTRY) {
        _this.checkIfJoinableTournament();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "chooseTeam", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(team) {
        var userAuth, currentTournamentId, updatedTournament, data, errorMessage;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getAuthToken();

              case 2:
                userAuth = _context.sent;
                currentTournamentId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_ID);

                if (!(userAuth && currentTournamentId && team.name)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 5;
                _context.next = 8;
                return _GameService["default"].chooseTournamentTeam(userAuth, currentTournamentId, team.name);

              case 8:
                updatedTournament = _context.sent;
                data = {};
                data[_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME] = team.name;
                data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS] = _this.getTournamentsWithUpdatedTournament(updatedTournament);

                _DataStore["default"].setData(data, false);

                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);
                errorMessage = (0, _ErrorHelper.getErrorMessage)(_context.t0);
                (0, _AlertHelper.showWideAlertHtml)(errorMessage, (0, _strings.getString)('FAILURE'));
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 15]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkTournamentCodeValidity", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(code) {
        var tournaments, tournament, userAuth;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                code = code.toLowerCase();
                tournaments = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS);
                tournament = (tournaments || []).find(function (tournament) {
                  return tournament.name.toLowerCase() === code && tournament.phase === TOURNAMENT_PHASES.CHOOSE_TEAM;
                });

                if (!tournament) {
                  _context2.next = 18;
                  break;
                }

                _context2.prev = 4;
                _context2.next = 7;
                return _this.getAuthToken();

              case 7:
                userAuth = _context2.sent;
                _context2.next = 10;
                return _GameService["default"].loadSpecificTournament(userAuth, tournament.id);

              case 10:
                tournament = _context2.sent;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](4);
                console.log('checkTournamentCodeValidity: error while trying to loadtournamentdata ', _context2.t0);

              case 16:
                _context2.next = 18;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, tournament);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 13]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserId", function () {
      // QD in KESI
      if (_BuildConstants.IS_KESI_APP) {
        /** {Feature} **/
        var feature = _FeatureManager["default"].getFeature('qdKesi');

        return feature.userId;
      } // old QD


      return _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH_ID);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAuthToken", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var tokenPart;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_BuildConstants.IS_KESI_APP) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return _RegisterInstance["default"].getAccessToken('quizGame:read quizGame:write');

            case 3:
              tokenPart = _context3.sent;
              return _context3.abrupt("return", "Bearer ".concat(tokenPart));

            case 5:
              return _context3.abrupt("return", _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH_AUTH));

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "leaveTournament", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var userAuth, userId, currentTournament, currentTournamentId, user, errorMessage;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              console.log('leaveTournament');
              _context4.next = 3;
              return _this.getAuthToken();

            case 3:
              userAuth = _context4.sent;
              userId = _this.getUserId();
              currentTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);
              currentTournamentId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_ID);

              if (userId) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return");

            case 9:
              // check if user has joined a team. If not we don't have to talk to the server
              user = QuizTournament.checkIfMemberOfTournament([currentTournament], userId);
              console.log('leaveTournament', userAuth, currentTournamentId, user);

              if (!(userAuth && currentTournamentId && user)) {
                _context4.next = 22;
                break;
              }

              _context4.prev = 12;
              _context4.next = 15;
              return _GameService["default"].leaveTournament(userAuth, currentTournamentId);

            case 15:
              _context4.next = 22;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](12);
              errorMessage = (0, _ErrorHelper.getErrorMessage)(_context4.t0);
              (0, _AlertHelper.showWideAlertHtml)(errorMessage, (0, _strings.getString)('FAILURE'));
              return _context4.abrupt("return");

            case 22:
              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, null);

              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME, null);

              _this.setState({
                page: PAGES.CODE_ENTRY
              });

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[12, 17]]);
    })));
    _this.state = {
      page: PAGES.CODE_ENTRY
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizTournament.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, _DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_ID, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH_ID, _DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME]);
    return _this;
  }

  (0, _createClass2["default"])(QuizTournament, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.props.setTitle('Turnier');

                _TournamentStateHelper["default"].addTournamentListener(_TournamentStateHelper.TOURNAMENT_COMMANDS.TOURNAMENTS_UPDATE, this.handleTournamentsUpdate);

                _TournamentStateHelper["default"].addTournamentListener(_TournamentStateHelper.TOURNAMENT_COMMANDS.MY_TOURNAMENT_UPDATE, this.handleTournamentUpdate);

                _context5.next = 5;
                return this.getInitialState();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _TournamentStateHelper["default"].removeTournamentListener(_TournamentStateHelper.TOURNAMENT_COMMANDS.TOURNAMENTS_UPDATE, this.handleTournamentsUpdate);

      _TournamentStateHelper["default"].removeTournamentListener(_TournamentStateHelper.TOURNAMENT_COMMANDS.MY_TOURNAMENT_UPDATE, this.handleTournamentUpdate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapShot) {
      if (prevState.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE] !== this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE]) {
        console.log('QUIZTOURNAMENT PHASE UPDATE: ', this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE]);
        this.handleTournamentPhaseChange(this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE]);
      }
    } // state not mapped yet so we gotta call datastore methods

  }, {
    key: "getInitialState",
    value: function () {
      var _getInitialState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var tournamentId, userId, tournaments, info, tournament, teamName, data;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                tournamentId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_ID);

                if (!tournamentId) {
                  _context6.next = 5;
                  break;
                }

                this.handleTournamentPhaseChange(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE));
                _context6.next = 24;
                break;

              case 5:
                userId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH_ID);
                tournaments = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS);
                info = QuizTournament.getTournamentDataIfMember(tournaments, userId);
                console.log('getTournamentDataIfMember', info);

                if (!info) {
                  _context6.next = 22;
                  break;
                }

                tournament = info.tournament;
                teamName = info.team['name'];
                data = {};
                data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT] = tournament;
                data[_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME] = teamName;
                console.log('USER WAS ALREADY IN A TEAM: ', tournament);
                _context6.next = 18;
                return _DataStore["default"].setData(data, false);

              case 18:
                _context6.next = 20;
                return this.handleTournamentPhaseChange(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE));

              case 20:
                _context6.next = 24;
                break;

              case 22:
                _context6.next = 24;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS, tournaments, false);

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getInitialState() {
        return _getInitialState.apply(this, arguments);
      }

      return getInitialState;
    }()
  }, {
    key: "handleTournamentPhaseChange",
    value: function () {
      var _handleTournamentPhaseChange = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(phase) {
        var _this2 = this;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('tournamentphase: ', phase);

                if (!(phase === TOURNAMENT_PHASES.CHOOSE_TEAM)) {
                  _context7.next = 5;
                  break;
                }

                this.setState({
                  page: PAGES.CHOOSE_TEAM
                });
                _context7.next = 29;
                break;

              case 5:
                if (!(phase === TOURNAMENT_PHASES.WAIT_FOR_PLAY)) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 8;
                return this.checkIfUserHasTeam();

              case 8:
                this.setState({
                  page: PAGES.WAIT_FOR_PLAY
                });
                _context7.next = 29;
                break;

              case 11:
                if (!(phase === TOURNAMENT_PHASES.PLAY_GAMES)) {
                  _context7.next = 18;
                  break;
                }

                _context7.next = 14;
                return this.checkIfUserHasTeam();

              case 14:
                _NavigationManager["default"].goToQuizHome(true);

                this.setState({
                  page: PAGES.PLAY_GAMES
                });
                _context7.next = 29;
                break;

              case 18:
                if (!(phase === TOURNAMENT_PHASES.WAIT_FOR_END)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 21;
                return this.checkIfUserHasTeam();

              case 21:
                _NavigationManager["default"].goToQuizHome(true);

                this.setState({
                  page: PAGES.WAIT_FOR_END
                });
                _context7.next = 29;
                break;

              case 25:
                if (!(phase === TOURNAMENT_PHASES.END)) {
                  _context7.next = 29;
                  break;
                }

                _context7.next = 28;
                return _TournamentStateHelper["default"].reloadTournamentData();

              case 28:
                if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT)) {
                  this.setState({
                    page: PAGES.END_SCREEN
                  });
                } else {
                  (0, _AlertHelper.showWideAlertHtml)('Das Turnier ist vorbei! Vielen Dank für´s Mitspielen!', 'Turnier beendet', false, {
                    label: 'Ok',
                    callback: function callback() {
                      QuizTournament.resetTournamentData();

                      _this2.setState({
                        page: PAGES.CODE_ENTRY
                      }); // NavigationManager.goHome()

                    }
                  });
                }

              case 29:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handleTournamentPhaseChange(_x3) {
        return _handleTournamentPhaseChange.apply(this, arguments);
      }

      return handleTournamentPhaseChange;
    }()
  }, {
    key: "checkIfUserHasTeam",
    value: function () {
      var _checkIfUserHasTeam = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var tournament, info;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                tournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT) || {};
                _context9.t0 = QuizTournament;
                _context9.t1 = [tournament];
                _context9.next = 5;
                return this.getUserId();

              case 5:
                _context9.t2 = _context9.sent;
                info = _context9.t0.getTournamentDataIfMember.call(_context9.t0, _context9.t1, _context9.t2);

                if (!info) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 10;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME, info.team.name, false);

              case 10:
                _context9.next = 13;
                break;

              case 12:
                (0, _AlertHelper.showWideAlertHtml)('Leider haben Sie kein Team gewählt. Sie können nicht am Turnier teilnehmen', 'Fehler', false, {
                  label: 'Ok',
                  callback: function () {
                    var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
                      return _regenerator["default"].wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              _context8.next = 2;
                              return QuizTournament.resetTournamentData();

                            case 2:
                              _NavigationManager["default"].goHome();

                            case 3:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8);
                    }));

                    function callback() {
                      return _callback.apply(this, arguments);
                    }

                    return callback;
                  }()
                });

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function checkIfUserHasTeam() {
        return _checkIfUserHasTeam.apply(this, arguments);
      }

      return checkIfUserHasTeam;
    }()
  }, {
    key: "checkIfJoinableTournament",
    value: function checkIfJoinableTournament() {
      var tournaments = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT) || [];

      var _iterator = _createForOfIteratorHelper(tournaments),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tournament = _step.value;

          if (tournament.hasOwnProperty('phase')) {
            if (tournament.phase === TOURNAMENT_PHASES.CHOOSE_TEAM) {
              return;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      (0, _AlertHelper.showWideAlertHtml)('Leider haben Sie kein Team gewählt. Sie können nicht am Turnier teilnehmen', 'Fehler', false, {
        label: 'Ok',
        callback: function () {
          var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
            return _regenerator["default"].wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return QuizTournament.resetTournamentData();

                  case 2:
                    _NavigationManager["default"].goHome();

                  case 3:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          }));

          function callback() {
            return _callback2.apply(this, arguments);
          }

          return callback;
        }()
      });
    }
  }, {
    key: "getTournamentsWithUpdatedTournament",
    value: function getTournamentsWithUpdatedTournament(updatedTournament) {
      var tournaments = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS);

      var index = tournaments.findIndex(function (tournament) {
        return tournament.id === updatedTournament.id;
      });

      if (index >= 0) {
        tournaments[index] = updatedTournament;
      }

      return tournaments;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.page === PAGES.CODE_ENTRY) {
        return /*#__PURE__*/_react["default"].createElement(_QuizTournamentCodeEntry["default"], {
          checkCodeValidity: this.checkTournamentCodeValidity
        });
      } else if (this.state.page === PAGES.CHOOSE_TEAM || this.state.page === PAGES.WAIT_FOR_PLAY) {
        return /*#__PURE__*/_react["default"].createElement(_QuizTournamentTeamChooser["default"], {
          leaveTournament: this.leaveTournament,
          chooseTeam: this.chooseTeam,
          tournamentData: _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT) || {},
          userId: _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH_ID),
          phase: _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE),
          user: _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER)
        });
      } else if (this.state.page === PAGES.END_SCREEN) {
        return /*#__PURE__*/_react["default"].createElement(_QuizTournamentEndScreen["default"], {
          tournament: _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT),
          myTeamName: _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME)
        });
      } else if (this.state.page === PAGES.PLAY_GAMES || this.state.page === PAGES.WAIT_FOR_END || this.state.page === PAGES.END) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }
    }
  }], [{
    key: "searchForRunningTournaments",
    value: function searchForRunningTournaments(tournaments, userId) {
      var chooseTeamAvailable = false;
      var playAvailable = false;
      var tournamentToReturn = null;
      tournaments.forEach(function (tournament) {
        if (tournament.phase === TOURNAMENT_PHASES.CHOOSE_TEAM) {
          console.log('tournament in phase choose team');
          chooseTeamAvailable = true;
        } else if (tournament.phase === TOURNAMENT_PHASES.PLAY_GAMES) {
          console.log('tournament in phase play, check if member');
          var playableTournament = QuizTournament.checkIfMemberOfTournament(tournaments, userId);
          console.log('tournament in phase play, check if member', playableTournament);

          if (playableTournament) {
            playAvailable = true;
            tournamentToReturn = playableTournament;
          }
        }
      });

      if (playAvailable) {
        return tournamentToReturn;
      } else {
        return chooseTeamAvailable;
      }
    }
  }]);
  return QuizTournament;
}(_DataStoreComponent2["default"]);

(0, _defineProperty2["default"])(QuizTournament, "getTournamentDataIfMember", function (tournaments, userId) {
  var tournamentData = null;
  console.log('getTournamentDataIfMember', tournaments);
  tournaments.forEach(function (tournament) {
    if (tournament.phase !== TOURNAMENT_PHASES.END) {
      if (tournament.teams) {
        (0, _keys["default"])(tournament.teams).forEach(function (teamKey) {
          var team = tournament.teams[teamKey];
          var user = team.members.find(function (member) {
            return member.id === userId;
          });

          if (user) {
            tournamentData = {
              tournament: tournament,
              team: team
            };
          }
        });
      }
    }
  });
  return tournamentData;
});
(0, _defineProperty2["default"])(QuizTournament, "checkIfMemberOfTournament", function (tournaments, userId) {
  var tournament = QuizTournament.getTournamentDataIfMember(tournaments, userId);
  return !!tournament;
});
(0, _defineProperty2["default"])(QuizTournament, "resetTournamentData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
  var data;
  return _regenerator["default"].wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          data = {};
          data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE] = false;
          data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS] = null;
          data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT] = null;
          data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED] = null;
          data[_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME] = null;
          _context11.next = 8;
          return _DataStore["default"].setData(data);

        case 8:
          console.log('resetTournamentData done');

          _TournamentStateHelper["default"].setupInitialState();

        case 10:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11);
})));
QuizTournament.propTypes = {
  setTitle: _propTypes["default"].func.isRequired
};
var _default = QuizTournament;
exports["default"] = _default;